const convertDataTables = (
  dashboardDataTables,
  accountdatatables,
  sampledatatables,
) => {
  //  for the dashdts in EDIT, reformat them
  let formattedData = { ...dashboardDataTables };
  Object.values(dashboardDataTables).forEach((dt, i) => {
    let isSample = dt.useSampleData && !dt?.AccountDataTableId ? true : false;
    let [sampleDT, accountDT] = [null, null];
    if (isSample) {
      sampleDT = Object.values(sampledatatables).find((sampledt) => {
        if (dt.SampleDataTableId) {
          return dt.SampleDataTableId === sampledt.id;
        } else {
          return;
        }
      });
    } else {
      accountDT = Object.values(accountdatatables).find((accountdt) => {
        if (dt.AccountDataTableId)
          return dt.AccountDataTableId === accountdt.id;
        else return dt.DataTable === accountdt.DataTable.id;
      });
    }
    formattedData[dt.id] = {
      ...dt,
      defsource: isSample ? 'fromSampleData' : 'fromConnectedData',
      integrationname: isSample
        ? sampleDT?.Integration?.name
        : accountDT
          ? accountDT.AccountIntegration?.Integration?.name
          : dt.SampleDataTable?.Integration?.name,
      name: isSample
        ? sampleDT?.DataTable?.name
        : accountDT
          ? accountDT.DataTable?.name
          : dt.SampleDataTable?.DataTable?.name,
      IntegrationId: isSample
        ? sampleDT?.Integration?.id
        : accountDT
          ? accountDT.AccountIntegration?.Integration?.id
          : dt.SampleDataTable?.Integration?.id,
      DataTableId: isSample
        ? sampleDT?.DataTable?.id
        : accountDT
          ? accountDT.DataTable?.id
          : dt.SampleDataTable?.DataTable?.id,
      slug: isSample
        ? sampleDT?.DataTable?.slug
        : accountDT
          ? accountDT.DataTable?.slug
          : dt.SampleDataTable?.slug,
      sheetId: isSample
        ? sampleDT?.DataTable?.sheetId
        : accountDT
          ? accountDT.DataTable?.sheetId
          : dt.SampleDataTable?.DataTable?.sheetId, //this is the data that ends up being dispatched as dataTables within the dashboarddatatable context. Adding the needed info to be able to work with Flatfile
    };
  });
  return formattedData;
};

export default convertDataTables;
